export default __webpack_public_path__ + "static/media/loader.a30a2e05.mp4";